import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import find from 'lodash.find';

import { mapboxStyles } from '../../constants/mapThemeOptions';

import { updateMapsEditor } from '../../actions/mapsEditorActions';

export class MapsEditorStylePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customStyleUrl: this.defaultStyleIsSelected(props.style) ? '' : props.style,
      customStyleUrlSaved: false,
      usingCustomStyle: this.defaultStyleIsSelected(props.style) ? false : true,
    }
  }

  defaultStyleIsSelected = (styleUrl) => {
    return find(mapboxStyles, { url: styleUrl });
  }

  handleDefaultStyleChange = (style) => {
    return () => {
      this.props.updateMapsEditor({ style: style })
      this.setState({ usingCustomStyle: false, customStyleUrl: '' });
    }
  }

  handleStyleTextFieldChange = () => {
    return (e) => {
      this.setState({ customStyleUrl: e.target.value })
    }
  }

  handleChange = (name) => {
    return event => {
      const { target: { value } } = event;
      this.props.updateMapsEditor({ [name]: value });
    }
  }

  setCustomStyle = () => {
   this.setState({ usingCustomStyle: true, customStyleUrlSaved: true });
   this.props.updateMapsEditor({ style: this.state.customStyleUrl });
  }

  renderStyles = () => {
    return mapboxStyles.map((style, key) => {
      const activeStyle = !this.state.usingCustomStyle && this.props.style === style.url;

      return (
        <div className="col-sm-3 maps-editor-style-option" key={key}>
          <label className={`maps-editor-style-option-in ${activeStyle ? 'active' : ''}`}>
            <input
              className="d-none"
              type="radio"
              name="style"
              value={style.url}
              checked={activeStyle}
              onChange={this.handleDefaultStyleChange(style.url)} />

            <img src={style.image} className="maps-editor-style-img" />
            <div className="maps-editor-style-name">
              {style.name}
            </div>
          </label>
        </div>
      )
    });
  }

  renderCustomStyleOption = () => {
    const { mapbox_client_key } = this.props;
    const mapboxClientKeyExists = mapbox_client_key && mapbox_client_key.length > 50 && mapbox_client_key.includes('pk.');

    if (!mapboxClientKeyExists) return;

    return (
      <div className="col-sm-6 maps-editor-style-option">
        <div className={`maps-editor-style-option-in no-pointer ${this.state.usingCustomStyle ? 'active' : ''}`}>
          <div className="pal">
            <div className="maps-editor-style-option-custom-details">
              <div><b>Use Custom Mapbox Style</b></div>
              <div className="maps-editor-style-option-custom-desc">
                <p>Add the Style URL from your Mapbox account to use a custom style. Learn more <a href="https://closeby.zendesk.com/hc/en-us/articles/360015805299" target="_blank">here</a>.</p>
              </div>
            </div>

            <input
              type="text"
              value={this.state.customStyleUrl}
              onChange={this.handleStyleTextFieldChange()}
              className="form-control mbm"
              placeholder="mapbox://styles..."
            />

            {this.state.customStyleUrl !== this.props.style ? (
              <a className="btn btn-default" onClick={this.setCustomStyle}>
                Enable Style
              </a>
            ) : (
              <a className="btn btn-default disabled" disabled>
                {this.state.customStyleUrlSaved ? 'Custom Style Set.' : 'Enable Custom Style'}
              </a>
            )}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <div className="maps-editor-form-group">
          <div className="maps-editor-label">
            Map Style
            <div className="maps-editor-sublabel">
              Select an underlying style to use for your map. If you'd like to use your own custom style using <a href="https://www.mapbox.com/mapbox-studio" target="_blank">Mapbox Studio</a>, you can learn more <a href="https://closeby.zendesk.com/hc/en-us/articles/360015805299" target="_blank">here</a>.
            </div>
          </div>
          <div className="container-fluid">
            <div className="row maps-editor-style-row">
              {this.renderStyles()}
              {this.renderCustomStyleOption()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.mapsEditor
  }
};

export default connect(mapStateToProps, { updateMapsEditor })(MapsEditorStylePicker);
